module.exports = __webpack_public_path__ + "img/hzzw.8b654473.jpg";